module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "75%"
    },
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by"), _c('br'), _vm._v("Grub Street"), _c('br'), _vm._v("The Basement"), _c('br'), _vm._v("10 Chivalry Road"), _c('br'), _vm._v("London SW11 1HT"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © 2003 Grub Street, London"), _c('br'), _vm._v("Text copyright © 2003 Oliver Clutton-Brock"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('b', [_vm._v("British Library Cataloguing in Publication Data")]), _c('br'), _vm._v("Clutton-Brock, Oliver"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Footprints on the sands of time: RAF Bomber Command prisoners-of-war 1939-1945"), _c('br'), _vm._v("1. Great Britain. Royal Air Force. Bomber Command – History"), _c('br'), _vm._v("2. World War, 1939-1945 – Prisoners and prisons, German"), _c('br'), _vm._v("I. Title"), _c('br'), _vm._v("940.5’47243")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('b', [_vm._v("ISBN: 1 904010 00 0"), _c('br'), _vm._v("\nHARDBACK ISBN: 978 1 90401 035 7"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 90916 630 1")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Dedication photo courtesy of verelst, John/National Archives of Canada/C-092414"), _c('br'), _vm._v("Typeset by Pearl Graphics, Hemel Hempstead")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed and bound in Great Britain by"), _c('br'), _vm._v("Biddles Ltd, Guildford and King’s Lynn")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_c('b', [_vm._v("Author’s note:")]), _vm._v(" Some of the revelations in this book may be upsetting to the families of those involved, especially with regard to the chapter Traitors and Collaborators. However, in the interests of historical truth I felt that it was important not to omit the sometimes painful events of those dark days of war. The facts reproduced are the result of extensive research and are based on the evidence in files readily available to the general public.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0